import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import axios from "axios";
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavDropdown from 'react-bootstrap/NavDropdown';
import LogoMando from "../../assets/images/logo-mando.png";
import "./menu.css";


function Menu() {

  
  const [items, setItems] = useState([]);

  let ud                  = sessionStorage.getItem('userData');
  let userData            = JSON.parse(ud);
  var ju                  = userData.jerarquia

  useEffect(()=>{

    const getData = () => {

      let ud                  = sessionStorage.getItem('userData');
      let userData            = JSON.parse(ud);

      const instance = axios.create({
        baseURL: '',
        timeout: 5000,
        headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
        });
  
      
        instance.get('../api/list-collections')
        .then(response => {
            //console.log()
            setItems(JSON.parse(response.data))
        })
    }

      getData()
  },[])
      
  

  switch (ju) {
    case 2:
      return (
        <Navbar collapseOnSelect expand="lg" data-bs-theme="dark" className="backmenu">
          <Container>
            <Navbar.Brand href="../"><img className="logo-top" src={LogoMando} alt="Mando Access" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Offcanvas data-bs-theme="dark" className="backmenu" id="responsive-navbar-nav" placement="end">
              <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                    Mando Access
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link href="../lector">Lector</Nav.Link>
                    <Nav.Link href="../lector-fisico">Lector Físico</Nav.Link>
                    <Nav.Link href="../venues">Venues</Nav.Link>
                    <Nav.Link href="../eventos">Eventos</Nav.Link>
                    <Nav.Link href="../invitados">Invitados</Nav.Link>
                  </Nav>
                  <Nav>
                    <NavDropdown title="Configuración" id="collapsible-nav-dropdown">
                      <NavDropdown.Item href="../usuarios">Usuarios</NavDropdown.Item>
                      <NavDropdown.Item href="../list-niveles">Niveles</NavDropdown.Item>
                      <NavDropdown.Item href="../list-grupos">Grupos</NavDropdown.Item>
                      <NavDropdown.Item href="../list-alumnos">Alumnos</NavDropdown.Item>
                      <NavDropdown.Item href="../list-collections">Collections (Reco)</NavDropdown.Item>
                      {/* 

                      {
                        items && items.length > 0 && items.map((item, index) => {
                            var liga = "../reco/"+item
                            return (
                                <NavDropdown.Item href={liga}>Lector ({item})</NavDropdown.Item>
                            )
                        })
                      } */}

                      <NavDropdown.Item href="../my-account">Mi cuenta</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="../logout">Logout</Nav.Link>
                  </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      );

    case 1:
        return (
          <Navbar collapseOnSelect expand="lg" data-bs-theme="dark" className="backmenu">
          <Container>
            <Navbar.Brand href="../"><img className="logo-top" src={LogoMando} alt="Mando Access" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Offcanvas data-bs-theme="dark" className="backmenu" id="responsive-navbar-nav" placement="end">
              <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                    Mando Access
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link href="../lector">Lector</Nav.Link>
                    <Nav.Link href="../lector-fisico">Lector Físico</Nav.Link>
                    <Nav.Link href="../logout">Logout</Nav.Link>
                  </Nav>
                  <Nav>
                    <NavDropdown title="Configuración" id="collapsible-nav-dropdown">
                      <NavDropdown.Item href="../my-account">Mi cuenta</NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        );

      case 0:
        return (
          <Navbar collapseOnSelect expand="lg" data-bs-theme="dark" className="backmenu">
          <Container>
            <Navbar.Brand href="../"><img className="logo-top" src={LogoMando} alt="Mando Access" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Offcanvas data-bs-theme="dark" className="backmenu" id="responsive-navbar-nav" placement="end">
              <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                    Mando Access
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link href="../lector">Lector</Nav.Link>
                    <Nav.Link href="../lector-fisico">Lector Físico</Nav.Link>
                    <Nav.Link href="../logout">Logout</Nav.Link>
                  </Nav>
                  <Nav>
                    <NavDropdown title="Configuración" id="collapsible-nav-dropdown">
                      <NavDropdown.Item href="../my-account">Mi cuenta</NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        );
      
      default:
      break;
  }

  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">Dominga</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="blogs">Blogs</Nav.Link>
            <Nav.Link href="contact">Contact</Nav.Link>
            <Nav.Link href="lector">Lector</Nav.Link>
            <Nav.Link href="productos">Productos</Nav.Link>
            
          </Nav>
          <Nav>
            <NavDropdown title="Logout" id="collapsible-nav-dropdown">
              <NavDropdown.Item href="usuarios">Usuarios</NavDropdown.Item>
              <NavDropdown.Item href="my-account">Mi cuenta</NavDropdown.Item>
              <NavDropdown.Item href="logout">Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;